import Action from 'actions';
import BaseLP from 'services/sports/default/base-lp';
import Const from 'constants';
import {calcQuantityOfReservedLineupsByExposure, countPlayerIdInLineups} from 'helpers/lineup-helper';
import {addRoleSuffix, getSimplexUnitName} from 'helpers/simplex-helper';
import {getPlayerService} from 'services/sports/factory';

export default class LpSinglegame extends BaseLP {
    modes = [Const.CAPTAIN_MODE, Const.FLEX_MODE];

    createGroupsOfStacks({incomingValues: {dispatch}}) {
        const {
            playersData: {preparedPlayers},
        } = Action.getState();
        dispatch(Action.do('createGroupsOfPositionStacks', preparedPlayers.groupedBy.teamAndPosition()));
    }

    preparePlayerByLPPlayerId({incomingValues: {id}}) {
        return this.exec('preparePlayerByLPPlayerId_ShowDown', {id});
    }

    prepareMaxSection({incomingValues = {}}) {
        return this.exec('prepareMaxSection_ShowDown', incomingValues);
    }

    prepareMaxRandomSection({incomingValues = {}}) {
        return this.exec('prepareMaxRandomSection_ShowDown', incomingValues);
    }

    prepareSectionByTeam({incomingValues = {}}) {
        return this.exec('prepareSectionByTeam_ShowDown', incomingValues);
    }

    prepareSectionByUniquePosition({incomingValues = {}}) {
        return this.exec('prepareSectionByUniquePosition_ShowDown', incomingValues);
    }

    prepareSectionByCaptainPosition({incomingValues = {}}) {
        return this.exec('prepareSectionByCaptainPosition_ShowDown', incomingValues);
    }

    prepareSectionBySalary({incomingValues = {}}) {
        const {salaryCap, playersData} = Action.getState();
        const {preparedPlayers} = playersData;
        const playersGroupedById = preparedPlayers.groupedBy.playerId();

        let statement = '';
        Object.keys(playersGroupedById).map((pId) => {
            let player = playersGroupedById[pId];
            let prefix = '+' + player.salary + getSimplexUnitName(pId);
            statement += addRoleSuffix({prefix, role: Const.CAPTAIN_MODE});
            statement += addRoleSuffix({prefix});
        });
        let result = statement + Const.STACKS_TYPE_AT_MOST + salaryCap.getInnerMax();
        if (salaryCap.isInnerMinDefault()) {
            result += '\n' + statement + Const.STACKS_TYPE_AT_LEAST + salaryCap.getInnerMin();
        }

        return result;
    }

    prepareSectionByPlayer({incomingValues = {}}) {
        return this.exec('prepareSectionByPlayer_ShowDown', incomingValues);
    }

    prepareSectionByCreatedLineups({incomingValues = {}}) {
        return this.exec('prepareSectionByCreatedLineups_ShowDown', incomingValues);
    }

    prepareSectionByExposureMax({incomingValues = {}}) {
        return this.exec('prepareSectionByExposureMax_ShowDown', incomingValues, {});
    }

    prepareSectionByExposureMin({incomingValues = {}}) {
        return this.exec('prepareSectionByExposureMin_ShowDown', incomingValues);
    }

    // prepareSectionByExposureMin({incomingValues = {}}) {
    //     const denyConstraints = this.store.get('denyConstraints', []);

    //     let result = '';
    //     if (inArray('exposureMin', denyConstraints)) {
    //         return result;
    //     }

    //     const {
    //         sportConfig,
    //         lineupsQuantity,
    //         playersData: {preparedPlayers},
    //     } = Action.getState();
    //     const availablePositions = {
    //         [Const.CAPTAIN_MODE]: 1,
    //         [Const.DEFAULT_MODE]: sportConfig.getPlayersInTeam() - 1,
    //     };
    //     const forbiddenPlayers = this.store.get('playersForbiddenByExposureMax', []);

    //     const softConstraintsByMode = {
    //         [Const.CAPTAIN_MODE]: '',
    //         [Const.DEFAULT_MODE]: '',
    //     };
    //     let hardConstraints = '';
    //     let positionsCoefficient = {};
    //     let residualLineupsQ = lineupsQuantity.getLineupsQuantity() - this.store.get('calculatedLineupsCount', 0);

    //     Object.keys(availablePositions).map((playerMode) => {
    //         const expMinPropName = getPlayerService(sportConfig).exec('definePropNameOfMode', {
    //             prop: 'exposureMin',
    //             mode: playerMode,
    //         });
    //         const playersGroupedByExposureMin = preparedPlayers.groupedBy.property(expMinPropName);

    //         if (isEmpty(playersGroupedByExposureMin)) {
    //             return;
    //         }

    //         Object.values(playersGroupedByExposureMin).map((players) => {
    //             players.map((player) => {
    //                 if (player.isExcludedByMode(playerMode, {salaryMode: Const.FLEX_MODE})) {
    //                     return;
    //                 }

    //                 let lpPlayerId = addRoleSuffix({prefix: player.getId(), role: playerMode});
    //                 let usedInLineups = countPlayerIdInLineups(lpPlayerId, this.store.get('lineups', []).join(''));
    //                 let reservedLineupsQ = calcQuantityOfReservedLineupsByExposure(
    //                     lineupsQuantity.getLineupsQuantity(),
    //                     player.getPropValueOfMode('exposureMin', playerMode),
    //                 );
    //                 let residualReservedLineupsQ = reservedLineupsQ - usedInLineups;

    //                 if (residualReservedLineupsQ > 0) {
    //                     if (residualReservedLineupsQ >= residualLineupsQ) {
    //                         if (!inArray(lpPlayerId, forbiddenPlayers)) {
    //                             hardConstraints += '+' + getSimplexUnitName(lpPlayerId) + '=1\n';
    //                         }
    //                     } else if (!inArray(lpPlayerId, forbiddenPlayers)) {
    //                         let coefficientReservedPlaces = residualReservedLineupsQ / residualLineupsQ;
    //                         if (!positionsCoefficient.hasOwnProperty(playerMode)) {
    //                             positionsCoefficient[playerMode] = 0;
    //                         }
    //                         positionsCoefficient[playerMode] += coefficientReservedPlaces;
    //                         softConstraintsByMode[playerMode] += '+' + getSimplexUnitName(lpPlayerId);
    //                     }
    //                 }
    //             });
    //         });
    //     });

    //     const amountCoefficientsByMode = {
    //         [Const.CAPTAIN_MODE]: 0,
    //         [Const.DEFAULT_MODE]: 0,
    //     };
    //     Object.keys(positionsCoefficient).map((playerMode) => {
    //         let coef = Math.ceil(positionsCoefficient[playerMode]);
    //         if (coef > availablePositions[playerMode]) {
    //             coef = availablePositions[playerMode];
    //         }

    //         amountCoefficientsByMode[playerMode] = coef;
    //     });

    //     Object.keys(amountCoefficientsByMode).map((playerMode) => {
    //         if (amountCoefficientsByMode[playerMode] > 0 && softConstraintsByMode[playerMode]) {
    //             softConstraintsByMode[playerMode] += '>=' + amountCoefficientsByMode[playerMode] + '\n';
    //         }
    //     });

    //     result = hardConstraints + Object.values(softConstraintsByMode).join('');

    //     return result;
    // }

    prepareGeneralSection({incomingValues = {}}) {
        return this.exec('prepareGeneralSection_ShowDown', incomingValues);
    }

    prepareBoundSection({incomingValues = {}}) {
        const state = Action.getState();
        const {preparedPlayers} = state.playersData;
        const playersGroupedById = preparedPlayers.groupedBy.playerId();

        const result = {};
        Object.keys(playersGroupedById).map((pId) => {
            let player = playersGroupedById[pId];
            let prefix = getSimplexUnitName(pId);

            const isExcludedByCapMode = player.isExcludedByMode(Const.CAPTAIN_MODE, {
                salaryMode: Const.FLEX_MODE,
            });
            result[addRoleSuffix({prefix, role: Const.CAPTAIN_MODE})] = {
                atLeast: 0,
                atMost: isExcludedByCapMode ? 0 : 1,
            };

            const isExcludedByFlexMode = player.isExcludedByMode(Const.FLEX_MODE);
            result[addRoleSuffix({prefix, role: Const.FLEX_MODE})] = {
                atLeast: 0,
                atMost: isExcludedByFlexMode ? 0 : 1,
            };
        });

        return result;
    }

    allowOnlyOneDSTPositionPerLineup({incomingValues = {}}) {
        const {
            lineupsData: {filters},
        } = Action.getState();

        if (!filters.allowOnlyOneDSTPositionPerLineup) {
            return [];
        }

        return this.exec('limitPositionsPerLineup', {
            ...incomingValues,
            limits: [{
                positionName: 'DEF',
                limit: 1,
            }],
        });
    }

    subjectToPermanent() {
        const constraints = {
            players: this.exec('prepareSectionByPlayer', {}, ''),
            salary: this.exec('prepareSectionBySalary', {}, ''),
            projectedOwnershipCap: this.exec('projectedOwnership', {modes: this.modes}, ''),
            projectedOwnershipForce: this.exec('forceOfProjectedOwnership', {modes: this.modes}, ''),
            teams: this.exec('prepareSectionByTeam', {}, ''),
            minTeams: this.exec('minTeams', {modes: this.modes}, ''),
            captainPositions: this.exec('prepareSectionByCaptainPosition', {}, ''),
            // cptStacks: this.exec('prepareSectionByCptStacks', {}, ''),
            keyPlayerStacking: this.exec('keyPlayerStacking', {modes: this.modes}, ''),
            stackQuarterbackWithPassReceivers: this.exec('stackQuarterbackWithPassReceivers', {}, ''),
            projectionBoostRule: this.exec('projectionBoostRule', {modes: this.modes}, ''),
            allowOnlyOneDSTPositionPerLineup: this.exec('allowOnlyOneDSTPositionPerLineup', {modes: this.modes}, ''),
        };

        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            uniquePositions: this.exec('prepareSectionByUniquePosition', {}, ''),
            createdLineups: this.exec('prepareSectionByCreatedLineups', {}, ''),
            singlegameForcedStacking: this.exec('singlegameForcedStacking', {}, ''),
            exposureMax: this.exec('prepareSectionByExposureMax', {}, ''),
            exposureMin: this.exec('prepareSectionByExposureMin', {}, ''),
            playerCombinationStacking: this.exec('playerCombinationStacking', {modes: this.modes}, ''),
        };

        return {...constraints};
    }
}
